
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {AuthenticationType} from '../core/AuthenticationType';
import {FieldModelAuthenticationType} from '../core/AuthenticationType';
import {ReportsSubscriptionType} from '../core/ReportsSubscriptionType';
import {FieldModelReportsSubscriptionType} from '../core/ReportsSubscriptionType';
import {FeaturesToggleForce} from '../core/FeaturesToggleForce';
import {FieldModelFeaturesToggleForce} from '../core/FeaturesToggleForce';
import {SocialTradingAccountType} from '../core/SocialTradingAccountType';
import {FieldModelSocialTradingAccountType} from '../core/SocialTradingAccountType';
import {SocialTradingMasterUpdate} from './SocialTradingMasterUpdate';
import {FieldModelSocialTradingMasterUpdate} from './SocialTradingMasterUpdate';
import {SocialTradingInvestorUpdate} from './SocialTradingInvestorUpdate';
import {FieldModelSocialTradingInvestorUpdate} from './SocialTradingInvestorUpdate';
import {TriStateEnablement} from '../core/TriStateEnablement';
import {FieldModelTriStateEnablement} from '../core/TriStateEnablement';

/**
 * AccountUpdate struct
 */
class AccountUpdate {
  /**
   * Initialize struct
   * @param {!number=} key
   * @param {number=} actualVersion
   * @param {UUID=} accountGroupId
   * @param {string=} name
   * @param {string=} country
   * @param {string=} city
   * @param {string=} state
   * @param {string=} zipCode
   * @param {string=} address
   * @param {string=} phone
   * @param {string=} email
   * @param {string=} identifier
   * @param {string=} status
   * @param {string=} comment
   * @param {string=} description
   * @param {boolean=} isEnabled
   * @param {!boolean=} isEnabledReset
   * @param {boolean=} isTradeEnabled
   * @param {!boolean=} isTradeEnabledReset
   * @param {AuthenticationType=} authenticationType
   * @param {string=} passwordDigest
   * @param {string=} phonePasswordDigest
   * @param {number=} agentAccount
   * @param {!boolean=} agentAccountReset
   * @param {number=} maxPendingOrders
   * @param {Date=} created
   * @param {Date=} modified
   * @param {Date=} archived
   * @param {Date=} deleted
   * @param {Date=} lastLogin
   * @param {string=} group
   * @param {string=} platform
   * @param {ReportsSubscriptionType=} reportsSubscriptionType
   * @param {number=} maxOrders
   * @param {string=} externalClientId
   * @param {!boolean=} externalClientIdReset
   * @param {string=} externalAccountId
   * @param {!boolean=} externalAccountIdReset
   * @param {string=} localLanguageName
   * @param {FeaturesToggleForce=} featuresToggleForce
   * @param {SocialTradingAccountType=} socialTradingAccountType
   * @param {SocialTradingMasterUpdate=} socialTradingMasterUpdate
   * @param {!boolean=} socialTradingMasterUpdateReset
   * @param {SocialTradingInvestorUpdate=} socialTradingInvestorUpdate
   * @param {!boolean=} socialTradingInvestorUpdateReset
   * @param {number=} disabledEventTypesMask
   * @param {string=} languageName
   * @param {TriStateEnablement=} botApiEnablement
   * @constructor
   */
  constructor (key = new UInt64(0, 0), actualVersion = null, accountGroupId = null, name = null, country = null, city = null, state = null, zipCode = null, address = null, phone = null, email = null, identifier = null, status = null, comment = null, description = null, isEnabled = null, isEnabledReset = false, isTradeEnabled = null, isTradeEnabledReset = false, authenticationType = null, passwordDigest = null, phonePasswordDigest = null, agentAccount = null, agentAccountReset = false, maxPendingOrders = null, created = null, modified = null, archived = null, deleted = null, lastLogin = null, group = null, platform = null, reportsSubscriptionType = null, maxOrders = null, externalClientId = null, externalClientIdReset = false, externalAccountId = null, externalAccountIdReset = false, localLanguageName = null, featuresToggleForce = null, socialTradingAccountType = null, socialTradingMasterUpdate = null, socialTradingMasterUpdateReset = false, socialTradingInvestorUpdate = null, socialTradingInvestorUpdateReset = false, disabledEventTypesMask = null, languageName = null, botApiEnablement = null) {
    this.Key = key
    this.ActualVersion = actualVersion
    this.AccountGroupId = accountGroupId
    this.Name = name
    this.Country = country
    this.City = city
    this.State = state
    this.ZipCode = zipCode
    this.Address = address
    this.Phone = phone
    this.Email = email
    this.Identifier = identifier
    this.Status = status
    this.Comment = comment
    this.Description = description
    this.IsEnabled = isEnabled
    this.IsEnabledReset = isEnabledReset
    this.IsTradeEnabled = isTradeEnabled
    this.IsTradeEnabledReset = isTradeEnabledReset
    this.AuthenticationType = authenticationType
    this.PasswordDigest = passwordDigest
    this.PhonePasswordDigest = phonePasswordDigest
    this.AgentAccount = agentAccount
    this.AgentAccountReset = agentAccountReset
    this.MaxPendingOrders = maxPendingOrders
    this.Created = created
    this.Modified = modified
    this.Archived = archived
    this.Deleted = deleted
    this.LastLogin = lastLogin
    this.Group = group
    this.Platform = platform
    this.ReportsSubscriptionType = reportsSubscriptionType
    this.MaxOrders = maxOrders
    this.ExternalClientId = externalClientId
    this.ExternalClientIdReset = externalClientIdReset
    this.ExternalAccountId = externalAccountId
    this.ExternalAccountIdReset = externalAccountIdReset
    this.LocalLanguageName = localLanguageName
    this.FeaturesToggleForce = featuresToggleForce
    this.SocialTradingAccountType = socialTradingAccountType
    this.SocialTradingMasterUpdate = socialTradingMasterUpdate
    this.SocialTradingMasterUpdateReset = socialTradingMasterUpdateReset
    this.SocialTradingInvestorUpdate = socialTradingInvestorUpdate
    this.SocialTradingInvestorUpdateReset = socialTradingInvestorUpdateReset
    this.DisabledEventTypesMask = disabledEventTypesMask
    this.LanguageName = languageName
    this.BotApiEnablement = botApiEnablement
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountUpdate}
   * @param {!AccountUpdate} other Other struct
   * @returns {!AccountUpdate} This struct
   */
  copy (other) {
    if (other.Key != null) {
      this.Key = UInt64.fromNumber(other.Key)
    } else {
      this.Key = null
    }
    if (other.ActualVersion != null) {
      this.ActualVersion = UInt64.fromNumber(other.ActualVersion)
    } else {
      this.ActualVersion = null
    }
    if (other.AccountGroupId != null) {
      this.AccountGroupId = new UUID(other.AccountGroupId)
    } else {
      this.AccountGroupId = null
    }
    if (other.Name != null) {
      this.Name = other.Name
    } else {
      this.Name = null
    }
    if (other.Country != null) {
      this.Country = other.Country
    } else {
      this.Country = null
    }
    if (other.City != null) {
      this.City = other.City
    } else {
      this.City = null
    }
    if (other.State != null) {
      this.State = other.State
    } else {
      this.State = null
    }
    if (other.ZipCode != null) {
      this.ZipCode = other.ZipCode
    } else {
      this.ZipCode = null
    }
    if (other.Address != null) {
      this.Address = other.Address
    } else {
      this.Address = null
    }
    if (other.Phone != null) {
      this.Phone = other.Phone
    } else {
      this.Phone = null
    }
    if (other.Email != null) {
      this.Email = other.Email
    } else {
      this.Email = null
    }
    if (other.Identifier != null) {
      this.Identifier = other.Identifier
    } else {
      this.Identifier = null
    }
    if (other.Status != null) {
      this.Status = other.Status
    } else {
      this.Status = null
    }
    if (other.Comment != null) {
      this.Comment = other.Comment
    } else {
      this.Comment = null
    }
    if (other.Description != null) {
      this.Description = other.Description
    } else {
      this.Description = null
    }
    if (other.IsEnabled != null) {
      this.IsEnabled = other.IsEnabled
    } else {
      this.IsEnabled = null
    }
    if (other.IsEnabledReset != null) {
      this.IsEnabledReset = other.IsEnabledReset
    } else {
      this.IsEnabledReset = null
    }
    if (other.IsTradeEnabled != null) {
      this.IsTradeEnabled = other.IsTradeEnabled
    } else {
      this.IsTradeEnabled = null
    }
    if (other.IsTradeEnabledReset != null) {
      this.IsTradeEnabledReset = other.IsTradeEnabledReset
    } else {
      this.IsTradeEnabledReset = null
    }
    if (other.AuthenticationType != null) {
      this.AuthenticationType = AuthenticationType.fromObject(other.AuthenticationType)
    } else {
      this.AuthenticationType = null
    }
    if (other.PasswordDigest != null) {
      this.PasswordDigest = other.PasswordDigest
    } else {
      this.PasswordDigest = null
    }
    if (other.PhonePasswordDigest != null) {
      this.PhonePasswordDigest = other.PhonePasswordDigest
    } else {
      this.PhonePasswordDigest = null
    }
    if (other.AgentAccount != null) {
      this.AgentAccount = UInt64.fromNumber(other.AgentAccount)
    } else {
      this.AgentAccount = null
    }
    if (other.AgentAccountReset != null) {
      this.AgentAccountReset = other.AgentAccountReset
    } else {
      this.AgentAccountReset = null
    }
    if (other.MaxPendingOrders != null) {
      this.MaxPendingOrders = UInt64.fromNumber(other.MaxPendingOrders)
    } else {
      this.MaxPendingOrders = null
    }
    if (other.Created != null) {
      if (other.Created instanceof Date) {
        this.Created = new Date(other.Created.getTime())
      } else {
        this.Created = new Date(Math.round(other.Created / 1000000))
      }
    } else {
      this.Created = null
    }
    if (other.Modified != null) {
      if (other.Modified instanceof Date) {
        this.Modified = new Date(other.Modified.getTime())
      } else {
        this.Modified = new Date(Math.round(other.Modified / 1000000))
      }
    } else {
      this.Modified = null
    }
    if (other.Archived != null) {
      if (other.Archived instanceof Date) {
        this.Archived = new Date(other.Archived.getTime())
      } else {
        this.Archived = new Date(Math.round(other.Archived / 1000000))
      }
    } else {
      this.Archived = null
    }
    if (other.Deleted != null) {
      if (other.Deleted instanceof Date) {
        this.Deleted = new Date(other.Deleted.getTime())
      } else {
        this.Deleted = new Date(Math.round(other.Deleted / 1000000))
      }
    } else {
      this.Deleted = null
    }
    if (other.LastLogin != null) {
      if (other.LastLogin instanceof Date) {
        this.LastLogin = new Date(other.LastLogin.getTime())
      } else {
        this.LastLogin = new Date(Math.round(other.LastLogin / 1000000))
      }
    } else {
      this.LastLogin = null
    }
    if (other.Group != null) {
      this.Group = other.Group
    } else {
      this.Group = null
    }
    if (other.Platform != null) {
      this.Platform = other.Platform
    } else {
      this.Platform = null
    }
    if (other.ReportsSubscriptionType != null) {
      this.ReportsSubscriptionType = ReportsSubscriptionType.fromObject(other.ReportsSubscriptionType)
    } else {
      this.ReportsSubscriptionType = null
    }
    if (other.MaxOrders != null) {
      this.MaxOrders = UInt64.fromNumber(other.MaxOrders)
    } else {
      this.MaxOrders = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = other.ExternalClientId
    } else {
      this.ExternalClientId = null
    }
    if (other.ExternalClientIdReset != null) {
      this.ExternalClientIdReset = other.ExternalClientIdReset
    } else {
      this.ExternalClientIdReset = null
    }
    if (other.ExternalAccountId != null) {
      this.ExternalAccountId = other.ExternalAccountId
    } else {
      this.ExternalAccountId = null
    }
    if (other.ExternalAccountIdReset != null) {
      this.ExternalAccountIdReset = other.ExternalAccountIdReset
    } else {
      this.ExternalAccountIdReset = null
    }
    if (other.LocalLanguageName != null) {
      this.LocalLanguageName = other.LocalLanguageName
    } else {
      this.LocalLanguageName = null
    }
    if (other.FeaturesToggleForce != null) {
      this.FeaturesToggleForce = FeaturesToggleForce.fromObject(other.FeaturesToggleForce)
    } else {
      this.FeaturesToggleForce = null
    }
    if (other.SocialTradingAccountType != null) {
      this.SocialTradingAccountType = SocialTradingAccountType.fromObject(other.SocialTradingAccountType)
    } else {
      this.SocialTradingAccountType = null
    }
    if (other.SocialTradingMasterUpdate != null) {
      this.SocialTradingMasterUpdate = SocialTradingMasterUpdate.fromObject(other.SocialTradingMasterUpdate)
    } else {
      this.SocialTradingMasterUpdate = null
    }
    if (other.SocialTradingMasterUpdateReset != null) {
      this.SocialTradingMasterUpdateReset = other.SocialTradingMasterUpdateReset
    } else {
      this.SocialTradingMasterUpdateReset = null
    }
    if (other.SocialTradingInvestorUpdate != null) {
      this.SocialTradingInvestorUpdate = SocialTradingInvestorUpdate.fromObject(other.SocialTradingInvestorUpdate)
    } else {
      this.SocialTradingInvestorUpdate = null
    }
    if (other.SocialTradingInvestorUpdateReset != null) {
      this.SocialTradingInvestorUpdateReset = other.SocialTradingInvestorUpdateReset
    } else {
      this.SocialTradingInvestorUpdateReset = null
    }
    if (other.DisabledEventTypesMask != null) {
      this.DisabledEventTypesMask = UInt64.fromNumber(other.DisabledEventTypesMask)
    } else {
      this.DisabledEventTypesMask = null
    }
    if (other.LanguageName != null) {
      this.LanguageName = other.LanguageName
    } else {
      this.LanguageName = null
    }
    if (other.BotApiEnablement != null) {
      this.BotApiEnablement = TriStateEnablement.fromObject(other.BotApiEnablement)
    } else {
      this.BotApiEnablement = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountUpdate}
   * @returns {!AccountUpdate} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountUpdateModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountUpdateModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountUpdate}
   * @param {!AccountUpdate} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountUpdate)) {
      throw new TypeError('Instance of AccountUpdate is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountUpdate}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Key: ((this.Key != null) ? this.Key.toNumber() : null),
      ActualVersion: ((this.ActualVersion != null) ? this.ActualVersion.toNumber() : null),
      AccountGroupId: ((this.AccountGroupId != null) ? this.AccountGroupId.toString() : null),
      Name: ((this.Name != null) ? this.Name : null),
      Country: ((this.Country != null) ? this.Country : null),
      City: ((this.City != null) ? this.City : null),
      State: ((this.State != null) ? this.State : null),
      ZipCode: ((this.ZipCode != null) ? this.ZipCode : null),
      Address: ((this.Address != null) ? this.Address : null),
      Phone: ((this.Phone != null) ? this.Phone : null),
      Email: ((this.Email != null) ? this.Email : null),
      Identifier: ((this.Identifier != null) ? this.Identifier : null),
      Status: ((this.Status != null) ? this.Status : null),
      Comment: ((this.Comment != null) ? this.Comment : null),
      Description: ((this.Description != null) ? this.Description : null),
      IsEnabled: ((this.IsEnabled != null) ? this.IsEnabled : null),
      IsEnabledReset: ((this.IsEnabledReset != null) ? this.IsEnabledReset : null),
      IsTradeEnabled: ((this.IsTradeEnabled != null) ? this.IsTradeEnabled : null),
      IsTradeEnabledReset: ((this.IsTradeEnabledReset != null) ? this.IsTradeEnabledReset : null),
      AuthenticationType: ((this.AuthenticationType != null) ? this.AuthenticationType : null),
      PasswordDigest: ((this.PasswordDigest != null) ? this.PasswordDigest : null),
      PhonePasswordDigest: ((this.PhonePasswordDigest != null) ? this.PhonePasswordDigest : null),
      AgentAccount: ((this.AgentAccount != null) ? this.AgentAccount.toNumber() : null),
      AgentAccountReset: ((this.AgentAccountReset != null) ? this.AgentAccountReset : null),
      MaxPendingOrders: ((this.MaxPendingOrders != null) ? this.MaxPendingOrders.toNumber() : null),
      Created: ((this.Created != null) ? (this.Created.getTime() * 1000000) : null),
      Modified: ((this.Modified != null) ? (this.Modified.getTime() * 1000000) : null),
      Archived: ((this.Archived != null) ? (this.Archived.getTime() * 1000000) : null),
      Deleted: ((this.Deleted != null) ? (this.Deleted.getTime() * 1000000) : null),
      LastLogin: ((this.LastLogin != null) ? (this.LastLogin.getTime() * 1000000) : null),
      Group: ((this.Group != null) ? this.Group : null),
      Platform: ((this.Platform != null) ? this.Platform : null),
      ReportsSubscriptionType: ((this.ReportsSubscriptionType != null) ? this.ReportsSubscriptionType : null),
      MaxOrders: ((this.MaxOrders != null) ? this.MaxOrders.toNumber() : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      ExternalClientIdReset: ((this.ExternalClientIdReset != null) ? this.ExternalClientIdReset : null),
      ExternalAccountId: ((this.ExternalAccountId != null) ? this.ExternalAccountId : null),
      ExternalAccountIdReset: ((this.ExternalAccountIdReset != null) ? this.ExternalAccountIdReset : null),
      LocalLanguageName: ((this.LocalLanguageName != null) ? this.LocalLanguageName : null),
      FeaturesToggleForce: ((this.FeaturesToggleForce != null) ? this.FeaturesToggleForce : null),
      SocialTradingAccountType: ((this.SocialTradingAccountType != null) ? this.SocialTradingAccountType : null),
      SocialTradingMasterUpdate: ((this.SocialTradingMasterUpdate != null) ? this.SocialTradingMasterUpdate : null),
      SocialTradingMasterUpdateReset: ((this.SocialTradingMasterUpdateReset != null) ? this.SocialTradingMasterUpdateReset : null),
      SocialTradingInvestorUpdate: ((this.SocialTradingInvestorUpdate != null) ? this.SocialTradingInvestorUpdate : null),
      SocialTradingInvestorUpdateReset: ((this.SocialTradingInvestorUpdateReset != null) ? this.SocialTradingInvestorUpdateReset : null),
      DisabledEventTypesMask: ((this.DisabledEventTypesMask != null) ? this.DisabledEventTypesMask.toNumber() : null),
      LanguageName: ((this.LanguageName != null) ? this.LanguageName : null),
      BotApiEnablement: ((this.BotApiEnablement != null) ? this.BotApiEnablement : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountUpdate.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountUpdate} other Object value
   * @returns {!AccountUpdate} Created struct
   */
  static fromObject (other) {
    return new AccountUpdate().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountUpdate}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountUpdate.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountUpdate}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4165
  }
}

export { AccountUpdate };

/**
 * Fast Binary Encoding AccountUpdate field model
 */
class FieldModelAccountUpdate extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Key = new fbe.FieldModelUInt64(buffer, 4 + 4)
    this.ActualVersion = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.Key.fbeOffset + this.Key.fbeSize), buffer, this.Key.fbeOffset + this.Key.fbeSize)
    this.AccountGroupId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.ActualVersion.fbeOffset + this.ActualVersion.fbeSize), buffer, this.ActualVersion.fbeOffset + this.ActualVersion.fbeSize)
    this.Name = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.AccountGroupId.fbeOffset + this.AccountGroupId.fbeSize), buffer, this.AccountGroupId.fbeOffset + this.AccountGroupId.fbeSize)
    this.Country = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Name.fbeOffset + this.Name.fbeSize), buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.City = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Country.fbeOffset + this.Country.fbeSize), buffer, this.Country.fbeOffset + this.Country.fbeSize)
    this.State = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.City.fbeOffset + this.City.fbeSize), buffer, this.City.fbeOffset + this.City.fbeSize)
    this.ZipCode = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.State.fbeOffset + this.State.fbeSize), buffer, this.State.fbeOffset + this.State.fbeSize)
    this.Address = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ZipCode.fbeOffset + this.ZipCode.fbeSize), buffer, this.ZipCode.fbeOffset + this.ZipCode.fbeSize)
    this.Phone = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Address.fbeOffset + this.Address.fbeSize), buffer, this.Address.fbeOffset + this.Address.fbeSize)
    this.Email = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Phone.fbeOffset + this.Phone.fbeSize), buffer, this.Phone.fbeOffset + this.Phone.fbeSize)
    this.Identifier = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Email.fbeOffset + this.Email.fbeSize), buffer, this.Email.fbeOffset + this.Email.fbeSize)
    this.Status = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Identifier.fbeOffset + this.Identifier.fbeSize), buffer, this.Identifier.fbeOffset + this.Identifier.fbeSize)
    this.Comment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Status.fbeOffset + this.Status.fbeSize), buffer, this.Status.fbeOffset + this.Status.fbeSize)
    this.Description = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Comment.fbeOffset + this.Comment.fbeSize), buffer, this.Comment.fbeOffset + this.Comment.fbeSize)
    this.IsEnabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.Description.fbeOffset + this.Description.fbeSize), buffer, this.Description.fbeOffset + this.Description.fbeSize)
    this.IsEnabledReset = new fbe.FieldModelBool(buffer, this.IsEnabled.fbeOffset + this.IsEnabled.fbeSize)
    this.IsTradeEnabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.IsEnabledReset.fbeOffset + this.IsEnabledReset.fbeSize), buffer, this.IsEnabledReset.fbeOffset + this.IsEnabledReset.fbeSize)
    this.IsTradeEnabledReset = new fbe.FieldModelBool(buffer, this.IsTradeEnabled.fbeOffset + this.IsTradeEnabled.fbeSize)
    this.AuthenticationType = new fbe.FieldModelOptional(new FieldModelAuthenticationType(buffer, this.IsTradeEnabledReset.fbeOffset + this.IsTradeEnabledReset.fbeSize), buffer, this.IsTradeEnabledReset.fbeOffset + this.IsTradeEnabledReset.fbeSize)
    this.PasswordDigest = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.AuthenticationType.fbeOffset + this.AuthenticationType.fbeSize), buffer, this.AuthenticationType.fbeOffset + this.AuthenticationType.fbeSize)
    this.PhonePasswordDigest = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.PasswordDigest.fbeOffset + this.PasswordDigest.fbeSize), buffer, this.PasswordDigest.fbeOffset + this.PasswordDigest.fbeSize)
    this.AgentAccount = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.PhonePasswordDigest.fbeOffset + this.PhonePasswordDigest.fbeSize), buffer, this.PhonePasswordDigest.fbeOffset + this.PhonePasswordDigest.fbeSize)
    this.AgentAccountReset = new fbe.FieldModelBool(buffer, this.AgentAccount.fbeOffset + this.AgentAccount.fbeSize)
    this.MaxPendingOrders = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.AgentAccountReset.fbeOffset + this.AgentAccountReset.fbeSize), buffer, this.AgentAccountReset.fbeOffset + this.AgentAccountReset.fbeSize)
    this.Created = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.MaxPendingOrders.fbeOffset + this.MaxPendingOrders.fbeSize), buffer, this.MaxPendingOrders.fbeOffset + this.MaxPendingOrders.fbeSize)
    this.Modified = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Created.fbeOffset + this.Created.fbeSize), buffer, this.Created.fbeOffset + this.Created.fbeSize)
    this.Archived = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Modified.fbeOffset + this.Modified.fbeSize), buffer, this.Modified.fbeOffset + this.Modified.fbeSize)
    this.Deleted = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Archived.fbeOffset + this.Archived.fbeSize), buffer, this.Archived.fbeOffset + this.Archived.fbeSize)
    this.LastLogin = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize), buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize)
    this.Group = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.LastLogin.fbeOffset + this.LastLogin.fbeSize), buffer, this.LastLogin.fbeOffset + this.LastLogin.fbeSize)
    this.Platform = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.Group.fbeOffset + this.Group.fbeSize), buffer, this.Group.fbeOffset + this.Group.fbeSize)
    this.ReportsSubscriptionType = new fbe.FieldModelOptional(new FieldModelReportsSubscriptionType(buffer, this.Platform.fbeOffset + this.Platform.fbeSize), buffer, this.Platform.fbeOffset + this.Platform.fbeSize)
    this.MaxOrders = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.ReportsSubscriptionType.fbeOffset + this.ReportsSubscriptionType.fbeSize), buffer, this.ReportsSubscriptionType.fbeOffset + this.ReportsSubscriptionType.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.MaxOrders.fbeOffset + this.MaxOrders.fbeSize), buffer, this.MaxOrders.fbeOffset + this.MaxOrders.fbeSize)
    this.ExternalClientIdReset = new fbe.FieldModelBool(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
    this.ExternalAccountId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ExternalClientIdReset.fbeOffset + this.ExternalClientIdReset.fbeSize), buffer, this.ExternalClientIdReset.fbeOffset + this.ExternalClientIdReset.fbeSize)
    this.ExternalAccountIdReset = new fbe.FieldModelBool(buffer, this.ExternalAccountId.fbeOffset + this.ExternalAccountId.fbeSize)
    this.LocalLanguageName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ExternalAccountIdReset.fbeOffset + this.ExternalAccountIdReset.fbeSize), buffer, this.ExternalAccountIdReset.fbeOffset + this.ExternalAccountIdReset.fbeSize)
    this.FeaturesToggleForce = new fbe.FieldModelOptional(new FieldModelFeaturesToggleForce(buffer, this.LocalLanguageName.fbeOffset + this.LocalLanguageName.fbeSize), buffer, this.LocalLanguageName.fbeOffset + this.LocalLanguageName.fbeSize)
    this.SocialTradingAccountType = new fbe.FieldModelOptional(new FieldModelSocialTradingAccountType(buffer, this.FeaturesToggleForce.fbeOffset + this.FeaturesToggleForce.fbeSize), buffer, this.FeaturesToggleForce.fbeOffset + this.FeaturesToggleForce.fbeSize)
    this.SocialTradingMasterUpdate = new fbe.FieldModelOptional(new FieldModelSocialTradingMasterUpdate(buffer, this.SocialTradingAccountType.fbeOffset + this.SocialTradingAccountType.fbeSize), buffer, this.SocialTradingAccountType.fbeOffset + this.SocialTradingAccountType.fbeSize)
    this.SocialTradingMasterUpdateReset = new fbe.FieldModelBool(buffer, this.SocialTradingMasterUpdate.fbeOffset + this.SocialTradingMasterUpdate.fbeSize)
    this.SocialTradingInvestorUpdate = new fbe.FieldModelOptional(new FieldModelSocialTradingInvestorUpdate(buffer, this.SocialTradingMasterUpdateReset.fbeOffset + this.SocialTradingMasterUpdateReset.fbeSize), buffer, this.SocialTradingMasterUpdateReset.fbeOffset + this.SocialTradingMasterUpdateReset.fbeSize)
    this.SocialTradingInvestorUpdateReset = new fbe.FieldModelBool(buffer, this.SocialTradingInvestorUpdate.fbeOffset + this.SocialTradingInvestorUpdate.fbeSize)
    this.DisabledEventTypesMask = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.SocialTradingInvestorUpdateReset.fbeOffset + this.SocialTradingInvestorUpdateReset.fbeSize), buffer, this.SocialTradingInvestorUpdateReset.fbeOffset + this.SocialTradingInvestorUpdateReset.fbeSize)
    this.LanguageName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.DisabledEventTypesMask.fbeOffset + this.DisabledEventTypesMask.fbeSize), buffer, this.DisabledEventTypesMask.fbeOffset + this.DisabledEventTypesMask.fbeSize)
    this.BotApiEnablement = new fbe.FieldModelOptional(new FieldModelTriStateEnablement(buffer, this.LanguageName.fbeOffset + this.LanguageName.fbeSize), buffer, this.LanguageName.fbeOffset + this.LanguageName.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Key.fbeSize + this.ActualVersion.fbeSize + this.AccountGroupId.fbeSize + this.Name.fbeSize + this.Country.fbeSize + this.City.fbeSize + this.State.fbeSize + this.ZipCode.fbeSize + this.Address.fbeSize + this.Phone.fbeSize + this.Email.fbeSize + this.Identifier.fbeSize + this.Status.fbeSize + this.Comment.fbeSize + this.Description.fbeSize + this.IsEnabled.fbeSize + this.IsEnabledReset.fbeSize + this.IsTradeEnabled.fbeSize + this.IsTradeEnabledReset.fbeSize + this.AuthenticationType.fbeSize + this.PasswordDigest.fbeSize + this.PhonePasswordDigest.fbeSize + this.AgentAccount.fbeSize + this.AgentAccountReset.fbeSize + this.MaxPendingOrders.fbeSize + this.Created.fbeSize + this.Modified.fbeSize + this.Archived.fbeSize + this.Deleted.fbeSize + this.LastLogin.fbeSize + this.Group.fbeSize + this.Platform.fbeSize + this.ReportsSubscriptionType.fbeSize + this.MaxOrders.fbeSize + this.ExternalClientId.fbeSize + this.ExternalClientIdReset.fbeSize + this.ExternalAccountId.fbeSize + this.ExternalAccountIdReset.fbeSize + this.LocalLanguageName.fbeSize + this.FeaturesToggleForce.fbeSize + this.SocialTradingAccountType.fbeSize + this.SocialTradingMasterUpdate.fbeSize + this.SocialTradingMasterUpdateReset.fbeSize + this.SocialTradingInvestorUpdate.fbeSize + this.SocialTradingInvestorUpdateReset.fbeSize + this.DisabledEventTypesMask.fbeSize + this.LanguageName.fbeSize + this.BotApiEnablement.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Key.fbeExtra + this.ActualVersion.fbeExtra + this.AccountGroupId.fbeExtra + this.Name.fbeExtra + this.Country.fbeExtra + this.City.fbeExtra + this.State.fbeExtra + this.ZipCode.fbeExtra + this.Address.fbeExtra + this.Phone.fbeExtra + this.Email.fbeExtra + this.Identifier.fbeExtra + this.Status.fbeExtra + this.Comment.fbeExtra + this.Description.fbeExtra + this.IsEnabled.fbeExtra + this.IsEnabledReset.fbeExtra + this.IsTradeEnabled.fbeExtra + this.IsTradeEnabledReset.fbeExtra + this.AuthenticationType.fbeExtra + this.PasswordDigest.fbeExtra + this.PhonePasswordDigest.fbeExtra + this.AgentAccount.fbeExtra + this.AgentAccountReset.fbeExtra + this.MaxPendingOrders.fbeExtra + this.Created.fbeExtra + this.Modified.fbeExtra + this.Archived.fbeExtra + this.Deleted.fbeExtra + this.LastLogin.fbeExtra + this.Group.fbeExtra + this.Platform.fbeExtra + this.ReportsSubscriptionType.fbeExtra + this.MaxOrders.fbeExtra + this.ExternalClientId.fbeExtra + this.ExternalClientIdReset.fbeExtra + this.ExternalAccountId.fbeExtra + this.ExternalAccountIdReset.fbeExtra + this.LocalLanguageName.fbeExtra + this.FeaturesToggleForce.fbeExtra + this.SocialTradingAccountType.fbeExtra + this.SocialTradingMasterUpdate.fbeExtra + this.SocialTradingMasterUpdateReset.fbeExtra + this.SocialTradingInvestorUpdate.fbeExtra + this.SocialTradingInvestorUpdateReset.fbeExtra + this.DisabledEventTypesMask.fbeExtra + this.LanguageName.fbeExtra + this.BotApiEnablement.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountUpdate.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4165
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountUpdate}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountUpdate}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Key.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Key.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Key.fbeSize

    if ((fbeCurrentSize + this.ActualVersion.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ActualVersion.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActualVersion.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Country.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Country.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Country.fbeSize

    if ((fbeCurrentSize + this.City.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.City.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.City.fbeSize

    if ((fbeCurrentSize + this.State.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.State.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.State.fbeSize

    if ((fbeCurrentSize + this.ZipCode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ZipCode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ZipCode.fbeSize

    if ((fbeCurrentSize + this.Address.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Address.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Address.fbeSize

    if ((fbeCurrentSize + this.Phone.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Phone.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Phone.fbeSize

    if ((fbeCurrentSize + this.Email.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Email.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Email.fbeSize

    if ((fbeCurrentSize + this.Identifier.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Identifier.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Identifier.fbeSize

    if ((fbeCurrentSize + this.Status.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Status.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Comment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Description.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.IsEnabledReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsEnabledReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabledReset.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsTradeEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabled.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabledReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsTradeEnabledReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabledReset.fbeSize

    if ((fbeCurrentSize + this.AuthenticationType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AuthenticationType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AuthenticationType.fbeSize

    if ((fbeCurrentSize + this.PasswordDigest.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PasswordDigest.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PasswordDigest.fbeSize

    if ((fbeCurrentSize + this.PhonePasswordDigest.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PhonePasswordDigest.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PhonePasswordDigest.fbeSize

    if ((fbeCurrentSize + this.AgentAccount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AgentAccount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AgentAccount.fbeSize

    if ((fbeCurrentSize + this.AgentAccountReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AgentAccountReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AgentAccountReset.fbeSize

    if ((fbeCurrentSize + this.MaxPendingOrders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MaxPendingOrders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxPendingOrders.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Created.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Modified.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Archived.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deleted.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.LastLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastLogin.fbeSize

    if ((fbeCurrentSize + this.Group.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Group.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Group.fbeSize

    if ((fbeCurrentSize + this.Platform.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Platform.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Platform.fbeSize

    if ((fbeCurrentSize + this.ReportsSubscriptionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ReportsSubscriptionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReportsSubscriptionType.fbeSize

    if ((fbeCurrentSize + this.MaxOrders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MaxOrders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxOrders.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.ExternalClientIdReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientIdReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientIdReset.fbeSize

    if ((fbeCurrentSize + this.ExternalAccountId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalAccountId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalAccountId.fbeSize

    if ((fbeCurrentSize + this.ExternalAccountIdReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalAccountIdReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalAccountIdReset.fbeSize

    if ((fbeCurrentSize + this.LocalLanguageName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LocalLanguageName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LocalLanguageName.fbeSize

    if ((fbeCurrentSize + this.FeaturesToggleForce.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FeaturesToggleForce.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeaturesToggleForce.fbeSize

    if ((fbeCurrentSize + this.SocialTradingAccountType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingAccountType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingAccountType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingMasterUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingMasterUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingMasterUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingMasterUpdateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingMasterUpdateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingMasterUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingInvestorUpdate.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingInvestorUpdate.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingInvestorUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingInvestorUpdateReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingInvestorUpdateReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingInvestorUpdateReset.fbeSize

    if ((fbeCurrentSize + this.DisabledEventTypesMask.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DisabledEventTypesMask.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DisabledEventTypesMask.fbeSize

    if ((fbeCurrentSize + this.LanguageName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LanguageName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LanguageName.fbeSize

    if ((fbeCurrentSize + this.BotApiEnablement.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.BotApiEnablement.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BotApiEnablement.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountUpdate}
   * @param {!AccountUpdate} fbeValue Default value, defaults is new AccountUpdate()
   * @returns {!AccountUpdate} AccountUpdate value
   */
  get (fbeValue = new AccountUpdate()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountUpdate}
   * @param {!AccountUpdate} fbeValue AccountUpdate value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Key.fbeSize) <= fbeStructSize) {
      fbeValue.Key = this.Key.get()
    } else {
      fbeValue.Key = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Key.fbeSize

    if ((fbeCurrentSize + this.ActualVersion.fbeSize) <= fbeStructSize) {
      fbeValue.ActualVersion = this.ActualVersion.get()
    } else {
      fbeValue.ActualVersion = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActualVersion.fbeSize

    if ((fbeCurrentSize + this.AccountGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupId = this.AccountGroupId.get()
    } else {
      fbeValue.AccountGroupId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupId.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Country.fbeSize) <= fbeStructSize) {
      fbeValue.Country = this.Country.get()
    } else {
      fbeValue.Country = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Country.fbeSize

    if ((fbeCurrentSize + this.City.fbeSize) <= fbeStructSize) {
      fbeValue.City = this.City.get()
    } else {
      fbeValue.City = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.City.fbeSize

    if ((fbeCurrentSize + this.State.fbeSize) <= fbeStructSize) {
      fbeValue.State = this.State.get()
    } else {
      fbeValue.State = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.State.fbeSize

    if ((fbeCurrentSize + this.ZipCode.fbeSize) <= fbeStructSize) {
      fbeValue.ZipCode = this.ZipCode.get()
    } else {
      fbeValue.ZipCode = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ZipCode.fbeSize

    if ((fbeCurrentSize + this.Address.fbeSize) <= fbeStructSize) {
      fbeValue.Address = this.Address.get()
    } else {
      fbeValue.Address = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Address.fbeSize

    if ((fbeCurrentSize + this.Phone.fbeSize) <= fbeStructSize) {
      fbeValue.Phone = this.Phone.get()
    } else {
      fbeValue.Phone = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Phone.fbeSize

    if ((fbeCurrentSize + this.Email.fbeSize) <= fbeStructSize) {
      fbeValue.Email = this.Email.get()
    } else {
      fbeValue.Email = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Email.fbeSize

    if ((fbeCurrentSize + this.Identifier.fbeSize) <= fbeStructSize) {
      fbeValue.Identifier = this.Identifier.get()
    } else {
      fbeValue.Identifier = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Identifier.fbeSize

    if ((fbeCurrentSize + this.Status.fbeSize) <= fbeStructSize) {
      fbeValue.Status = this.Status.get()
    } else {
      fbeValue.Status = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) <= fbeStructSize) {
      fbeValue.Comment = this.Comment.get()
    } else {
      fbeValue.Comment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) <= fbeStructSize) {
      fbeValue.Description = this.Description.get()
    } else {
      fbeValue.Description = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsEnabled = this.IsEnabled.get()
    } else {
      fbeValue.IsEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.IsEnabledReset.fbeSize) <= fbeStructSize) {
      fbeValue.IsEnabledReset = this.IsEnabledReset.get()
    } else {
      fbeValue.IsEnabledReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabledReset.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsTradeEnabled = this.IsTradeEnabled.get()
    } else {
      fbeValue.IsTradeEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabled.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabledReset.fbeSize) <= fbeStructSize) {
      fbeValue.IsTradeEnabledReset = this.IsTradeEnabledReset.get()
    } else {
      fbeValue.IsTradeEnabledReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabledReset.fbeSize

    if ((fbeCurrentSize + this.AuthenticationType.fbeSize) <= fbeStructSize) {
      fbeValue.AuthenticationType = this.AuthenticationType.get()
    } else {
      fbeValue.AuthenticationType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AuthenticationType.fbeSize

    if ((fbeCurrentSize + this.PasswordDigest.fbeSize) <= fbeStructSize) {
      fbeValue.PasswordDigest = this.PasswordDigest.get()
    } else {
      fbeValue.PasswordDigest = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PasswordDigest.fbeSize

    if ((fbeCurrentSize + this.PhonePasswordDigest.fbeSize) <= fbeStructSize) {
      fbeValue.PhonePasswordDigest = this.PhonePasswordDigest.get()
    } else {
      fbeValue.PhonePasswordDigest = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PhonePasswordDigest.fbeSize

    if ((fbeCurrentSize + this.AgentAccount.fbeSize) <= fbeStructSize) {
      fbeValue.AgentAccount = this.AgentAccount.get()
    } else {
      fbeValue.AgentAccount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AgentAccount.fbeSize

    if ((fbeCurrentSize + this.AgentAccountReset.fbeSize) <= fbeStructSize) {
      fbeValue.AgentAccountReset = this.AgentAccountReset.get()
    } else {
      fbeValue.AgentAccountReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AgentAccountReset.fbeSize

    if ((fbeCurrentSize + this.MaxPendingOrders.fbeSize) <= fbeStructSize) {
      fbeValue.MaxPendingOrders = this.MaxPendingOrders.get()
    } else {
      fbeValue.MaxPendingOrders = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxPendingOrders.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) <= fbeStructSize) {
      fbeValue.Created = this.Created.get()
    } else {
      fbeValue.Created = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) <= fbeStructSize) {
      fbeValue.Modified = this.Modified.get()
    } else {
      fbeValue.Modified = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) <= fbeStructSize) {
      fbeValue.Archived = this.Archived.get()
    } else {
      fbeValue.Archived = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) <= fbeStructSize) {
      fbeValue.Deleted = this.Deleted.get()
    } else {
      fbeValue.Deleted = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.LastLogin.fbeSize) <= fbeStructSize) {
      fbeValue.LastLogin = this.LastLogin.get()
    } else {
      fbeValue.LastLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastLogin.fbeSize

    if ((fbeCurrentSize + this.Group.fbeSize) <= fbeStructSize) {
      fbeValue.Group = this.Group.get()
    } else {
      fbeValue.Group = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Group.fbeSize

    if ((fbeCurrentSize + this.Platform.fbeSize) <= fbeStructSize) {
      fbeValue.Platform = this.Platform.get()
    } else {
      fbeValue.Platform = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Platform.fbeSize

    if ((fbeCurrentSize + this.ReportsSubscriptionType.fbeSize) <= fbeStructSize) {
      fbeValue.ReportsSubscriptionType = this.ReportsSubscriptionType.get()
    } else {
      fbeValue.ReportsSubscriptionType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReportsSubscriptionType.fbeSize

    if ((fbeCurrentSize + this.MaxOrders.fbeSize) <= fbeStructSize) {
      fbeValue.MaxOrders = this.MaxOrders.get()
    } else {
      fbeValue.MaxOrders = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxOrders.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.ExternalClientIdReset.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientIdReset = this.ExternalClientIdReset.get()
    } else {
      fbeValue.ExternalClientIdReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientIdReset.fbeSize

    if ((fbeCurrentSize + this.ExternalAccountId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalAccountId = this.ExternalAccountId.get()
    } else {
      fbeValue.ExternalAccountId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalAccountId.fbeSize

    if ((fbeCurrentSize + this.ExternalAccountIdReset.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalAccountIdReset = this.ExternalAccountIdReset.get()
    } else {
      fbeValue.ExternalAccountIdReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalAccountIdReset.fbeSize

    if ((fbeCurrentSize + this.LocalLanguageName.fbeSize) <= fbeStructSize) {
      fbeValue.LocalLanguageName = this.LocalLanguageName.get()
    } else {
      fbeValue.LocalLanguageName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LocalLanguageName.fbeSize

    if ((fbeCurrentSize + this.FeaturesToggleForce.fbeSize) <= fbeStructSize) {
      fbeValue.FeaturesToggleForce = this.FeaturesToggleForce.get()
    } else {
      fbeValue.FeaturesToggleForce = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeaturesToggleForce.fbeSize

    if ((fbeCurrentSize + this.SocialTradingAccountType.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingAccountType = this.SocialTradingAccountType.get()
    } else {
      fbeValue.SocialTradingAccountType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingAccountType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingMasterUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingMasterUpdate = this.SocialTradingMasterUpdate.get()
    } else {
      fbeValue.SocialTradingMasterUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingMasterUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingMasterUpdateReset.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingMasterUpdateReset = this.SocialTradingMasterUpdateReset.get()
    } else {
      fbeValue.SocialTradingMasterUpdateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingMasterUpdateReset.fbeSize

    if ((fbeCurrentSize + this.SocialTradingInvestorUpdate.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingInvestorUpdate = this.SocialTradingInvestorUpdate.get()
    } else {
      fbeValue.SocialTradingInvestorUpdate = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingInvestorUpdate.fbeSize

    if ((fbeCurrentSize + this.SocialTradingInvestorUpdateReset.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingInvestorUpdateReset = this.SocialTradingInvestorUpdateReset.get()
    } else {
      fbeValue.SocialTradingInvestorUpdateReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingInvestorUpdateReset.fbeSize

    if ((fbeCurrentSize + this.DisabledEventTypesMask.fbeSize) <= fbeStructSize) {
      fbeValue.DisabledEventTypesMask = this.DisabledEventTypesMask.get()
    } else {
      fbeValue.DisabledEventTypesMask = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DisabledEventTypesMask.fbeSize

    if ((fbeCurrentSize + this.LanguageName.fbeSize) <= fbeStructSize) {
      fbeValue.LanguageName = this.LanguageName.get()
    } else {
      fbeValue.LanguageName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LanguageName.fbeSize

    if ((fbeCurrentSize + this.BotApiEnablement.fbeSize) <= fbeStructSize) {
      fbeValue.BotApiEnablement = this.BotApiEnablement.get()
    } else {
      fbeValue.BotApiEnablement = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.BotApiEnablement.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountUpdate}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountUpdate}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountUpdate}
   * @param {!AccountUpdate} fbeValue AccountUpdate value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountUpdate}
   * @param {AccountUpdate} fbeValue AccountUpdate value
   */
  setFields (fbeValue) {
    this.Key.set(fbeValue.Key)
    this.ActualVersion.set(fbeValue.ActualVersion)
    this.AccountGroupId.set(fbeValue.AccountGroupId)
    this.Name.set(fbeValue.Name)
    this.Country.set(fbeValue.Country)
    this.City.set(fbeValue.City)
    this.State.set(fbeValue.State)
    this.ZipCode.set(fbeValue.ZipCode)
    this.Address.set(fbeValue.Address)
    this.Phone.set(fbeValue.Phone)
    this.Email.set(fbeValue.Email)
    this.Identifier.set(fbeValue.Identifier)
    this.Status.set(fbeValue.Status)
    this.Comment.set(fbeValue.Comment)
    this.Description.set(fbeValue.Description)
    this.IsEnabled.set(fbeValue.IsEnabled)
    this.IsEnabledReset.set(fbeValue.IsEnabledReset)
    this.IsTradeEnabled.set(fbeValue.IsTradeEnabled)
    this.IsTradeEnabledReset.set(fbeValue.IsTradeEnabledReset)
    this.AuthenticationType.set(fbeValue.AuthenticationType)
    this.PasswordDigest.set(fbeValue.PasswordDigest)
    this.PhonePasswordDigest.set(fbeValue.PhonePasswordDigest)
    this.AgentAccount.set(fbeValue.AgentAccount)
    this.AgentAccountReset.set(fbeValue.AgentAccountReset)
    this.MaxPendingOrders.set(fbeValue.MaxPendingOrders)
    this.Created.set(fbeValue.Created)
    this.Modified.set(fbeValue.Modified)
    this.Archived.set(fbeValue.Archived)
    this.Deleted.set(fbeValue.Deleted)
    this.LastLogin.set(fbeValue.LastLogin)
    this.Group.set(fbeValue.Group)
    this.Platform.set(fbeValue.Platform)
    this.ReportsSubscriptionType.set(fbeValue.ReportsSubscriptionType)
    this.MaxOrders.set(fbeValue.MaxOrders)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.ExternalClientIdReset.set(fbeValue.ExternalClientIdReset)
    this.ExternalAccountId.set(fbeValue.ExternalAccountId)
    this.ExternalAccountIdReset.set(fbeValue.ExternalAccountIdReset)
    this.LocalLanguageName.set(fbeValue.LocalLanguageName)
    this.FeaturesToggleForce.set(fbeValue.FeaturesToggleForce)
    this.SocialTradingAccountType.set(fbeValue.SocialTradingAccountType)
    this.SocialTradingMasterUpdate.set(fbeValue.SocialTradingMasterUpdate)
    this.SocialTradingMasterUpdateReset.set(fbeValue.SocialTradingMasterUpdateReset)
    this.SocialTradingInvestorUpdate.set(fbeValue.SocialTradingInvestorUpdate)
    this.SocialTradingInvestorUpdateReset.set(fbeValue.SocialTradingInvestorUpdateReset)
    this.DisabledEventTypesMask.set(fbeValue.DisabledEventTypesMask)
    this.LanguageName.set(fbeValue.LanguageName)
    this.BotApiEnablement.set(fbeValue.BotApiEnablement)
  }
}

export { FieldModelAccountUpdate };

/**
 * Fast Binary Encoding AccountUpdate model
 */
class AccountUpdateModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountUpdate(this.buffer, 4)
  }

  /**
   * Get the AccountUpdate model
   * @this {!AccountUpdateModel}
   * @returns {!FieldModelAccountUpdate} model AccountUpdate model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountUpdateModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountUpdateModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountUpdateModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountUpdateModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountUpdate.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountUpdateModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountUpdateModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountUpdateModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountUpdateModel}
   * @param {!AccountUpdate} value AccountUpdate value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountUpdateModel}
   * @param {!AccountUpdate} value AccountUpdate value, defaults is new AccountUpdate()
   * @return {!object} Deserialized AccountUpdate value and its size
   */
  deserialize (value = new AccountUpdate()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountUpdate(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountUpdate(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountUpdateModel}
   * @param {!number} prev Previous AccountUpdate model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountUpdateModel };
